import { tr } from "../../i18n";
interface BudgetHeroCardProps {
  saldoMilioni: number | null;
  numRinnovi?: number;
  numPosseduti?: number;
  numIscritti?: number;
  iscrittiTarget?: number;
  prossimoRibasso?: string; // es. tr("+50M a gennaio")
}

export function BudgetHeroCard({
  saldoMilioni,
  numRinnovi,
  numPosseduti,
  numIscritti,
  iscrittiTarget = 25,
  prossimoRibasso,
}: BudgetHeroCardProps) {
  return (
    <div className="relative bg-gradient-to-br from-primary to-primary-deep rounded-card p-5 overflow-hidden shadow-hero">
      {/* Glow oro angolo */}
      <div
        aria-hidden
        className="absolute -top-10 -right-10 w-36 h-36 rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(212,175,55,0.18) 0%, transparent 70%)",
        }}
      />
      <div className="relative">
        <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-accent mb-1">
          {tr("Budget disponibile")}
        </div>
        <div className="font-display text-5xl leading-none tracking-wide text-fg">
          {saldoMilioni === null ? "—" : saldoMilioni.toFixed(2)}
          <span className="text-base font-sans text-fg-muted ml-2">{tr("milioni")}</span>
        </div>
        {prossimoRibasso && (
          <div className="text-xs text-fg-muted mt-1">
            {tr("Saldo aggiornato ·")} <strong className="text-success">{prossimoRibasso}</strong>
          </div>
        )}

        {(numRinnovi !== undefined || numPosseduti !== undefined || numIscritti !== undefined) && (
          <div className="flex gap-3 mt-4 pt-4 border-t border-primary/30">
            {numRinnovi !== undefined && (
              <div className="flex-1">
                <div className="text-[10px] text-fg-muted uppercase tracking-wider">
                  {tr("Rinnovi attivi")}
                </div>
                <div className="font-mono font-bold text-fg mt-0.5">{numRinnovi}</div>
              </div>
            )}
            {numPosseduti !== undefined && (
              <div className="flex-1">
                <div className="text-[10px] text-fg-muted uppercase tracking-wider">
                  {tr("Posseduti")}
                </div>
                <div className="font-mono font-bold text-fg mt-0.5">{numPosseduti}</div>
              </div>
            )}
            {numIscritti !== undefined && (
              <div className="flex-1">
                <div className="text-[10px] text-fg-muted uppercase tracking-wider">
                  {tr("Iscritti")}
                </div>
                <div className="font-mono font-bold text-fg mt-0.5">
                  {numIscritti}/{iscrittiTarget}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
